// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguageSelectorPopupDesktop_container__HHDbP"};